import { Command } from 'commander';
import chalk from 'chalk';
import { initCommand } from '../commands/initCommand';
import { startCommand } from '../commands/startCommand';
import { createStartWithAppCommand } from '../commands/startWithAppCommand';
import { recordCommand } from '../commands/recordCommand';
import { replayCommand } from '../commands/replayCommand';
// import { createProxyCommand } from '../commands/proxyCommand'; // 임시 주석 처리

const program = new Command();

program
  .name('debug-time-machine')
  .description('Debug Time Machine CLI - 시간여행 디버깅 도구')
  .version('1.0.0');

// Init command
program
  .command('init')
  .description('새로운 Debug Time Machine 프로젝트를 초기화합니다')
  .option('-n, --name <n>', '프로젝트 이름')
  .option('-t, --template <template>', '템플릿 선택 (react, node, express)', 'react')
  .action(initCommand);

// Start command
program
  .command('start')
  .description('Debug Time Machine 서버를 시작합니다')
  .option('-p, --port <port>', '포트 번호', '3001')
  .option('-h, --host <host>', '호스트 주소', 'localhost')
  .action(startCommand);

// Start with app command (NEW!)
program.addCommand(createStartWithAppCommand());

// Record command
program
  .command('record')
  .description('애플리케이션 상태를 기록합니다')
  .option('-o, --output <file>', '출력 파일명', 'recording.json')
  .option('-d, --duration <seconds>', '기록 시간 (초)', '60')
  .action(recordCommand);

// Replay command
program
  .command('replay')
  .description('기록된 상태를 재생합니다')
  .option('-i, --input <file>', '입력 파일명', 'recording.json')
  .option('-s, --speed <speed>', '재생 속도', '1')
  .action(replayCommand);

// Proxy command (NEW!) - 임시 비활성화
// program.addCommand(createProxyCommand());

// Quick proxy shortcut - 임시 비활성화  
// program
//   .option('--target <url>', '프록시할 대상 URL (빠른 실행용)')
//   .option('--proxy-port <port>', '프록시 서버 포트', '8080')
//   .action((options) => {
//     if (options.target) {
//       // Quick proxy mode: debug-time-machine --target http://localhost:3000
//       const proxyCommand = createProxyCommand();
//       proxyCommand.parse(['proxy', options.target, '--port', String(options.proxyPort)], { from: 'user' });
//     }
//   });

// Error handling
program.on('command:*', () => {
  console.error(chalk.red(`Invalid command: ${program.args.join(' ')}`));
  console.log(chalk.yellow('See --help for a list of available commands.'));
  process.exit(1);
});

// Custom help
program.on('--help', () => {
  console.log('');
  console.log(chalk.bold('Examples:'));
  console.log('  $ debug-time-machine start --port 3001');
  console.log('  $ debug-time-machine start-with-app "npm start"');
  console.log('  $ debug-time-machine start-with-app "yarn dev"');
  console.log('  $ debug-time-machine init --name my-app --template react');
  console.log('');
  console.log(chalk.bold('Quick Start:'));
  console.log('  1. npm install debug-time-machine-react-client');
  console.log('  2. Add useDebugTimeMachine({ autoConnect: true }) to your app');
  console.log('  3. Run: debug-time-machine start-with-app "npm start"');
  console.log('  4. Everything auto-connects! 🎉');
});

// Parse arguments
program.parse();

// Show help if no arguments
if (!process.argv.slice(2).length) {
  program.outputHelp();
}
